import React from 'react';
import { SearchProvider } from './src/context/search-context';

// ⚠️ ORDINE IMPORTANTE: prima gli stili globali, poi quelli di Prism (che
// devono poter sovrascrivere i blocchi di codice).
// Questi due .css finiscono INLINE nell'<head> del render lato server
// (<style data-identity="gatsby-global-css">), quindi valgono gia' al primo
// disegno. Vedi la nota in cima a globale.css: e' il motivo per cui gli stili
// globali NON stanno piu' in un createGlobalStyle.
import './src/styles/globale.css';
import './src/components/prism-coldark-dark.css';

// Abilita le transizioni del tema solo DOPO il primo render, così il
// caricamento/reload non mostra la dissolvenza chiaro -> scuro.
export const onInitialClientRender = () => {
  requestAnimationFrame(() => {
    if (typeof document !== 'undefined') {
      document.body.classList.add('theme-ready');
    }
  });
};

// Scroll in cima ad ogni cambio pagina, in modo DETERMINISTICO.
// Lo scroll automatico di Gatsby a volte fallisce (race col rendering della
// pagina di destinazione: la ricetta si apriva scrollata in basso). Qui lo
// disattiviamo e scrolliamo noi dopo il paint (doppio requestAnimationFrame).
export const shouldUpdateScroll = () => false;

export const onRouteUpdate = () => {
  if (typeof window === 'undefined') return;
  requestAnimationFrame(() => requestAnimationFrame(() => window.scrollTo(0, 0)));
};

// Wrapper PERSISTENTE: il provider di ricerca resta montato una volta sola,
// senza rimontarsi ad ogni navigazione.
export const wrapRootElement = ({ element }) => <SearchProvider>{element}</SearchProvider>;
